import { useEffect, useRef } from "react";

export interface ZipPlace {
  state: string;
  city: string;
}

export async function lookupZip(zip: string): Promise<ZipPlace | null> {
  const digits = zip.replace(/\D/g, "");
  if (digits.length !== 5 && digits.length !== 9) return null;
  try {
    const res = await fetch(`https://api.zippopotam.us/us/${digits.slice(0, 5)}`);
    if (!res.ok) return null;
    const data = (await res.json()) as
      | { places?: Array<{ "state abbreviation"?: string; "place name"?: string }> }
      | null;
    const place = data?.places?.[0];
    if (!place) return null;
    const state = place["state abbreviation"] ?? "";
    const city = place["place name"] ?? "";
    return state || city ? { state, city } : null;
  } catch {
    return null;
  }
}

export function useZipAutoFill(zip: string, onResolve: (state: string, city: string) => void) {
  const cbRef = useRef(onResolve);
  cbRef.current = onResolve;
  useEffect(() => {
    let cancelled = false;
    lookupZip(zip).then((place) => {
      if (cancelled || !place) return;
      cbRef.current(place.state, place.city);
    });
    return () => { cancelled = true; };
  }, [zip]);
}
